/*
 * @Author: Ryan
 * @Date: 2026-01-14
 * @Description: SEO sections entry file for ai-video-generator page
 */
import React from 'react';

import VideoGeneratorHeroPlayer from '../_components/VideoGeneratorHeroPlayer';
import ComparisonSection from './ComparisonSection';
import CTASection from './CTASection';
import ExploreToolsSection from './ExploreToolsSection';
import FAQSection from './FAQSection';
import HeroSection from './HeroSection';
import HowToUseSection from './HowToUseSection';
import PowerfulFeaturesSection from './PowerfulFeaturesSection';
import TestimonialsSection from './TestimonialsSection';
import UseCasesSection from './UseCasesSection';
import WhyChooseSection from './WhyChooseSection';

const SEOSections: React.FC = () => {
  return (
    <>
      {/* SSR 渲染的 Hero 视频播放器 - 用于 SEO 抓取，视觉上隐藏 */}
      <div
        style={{
          position: 'absolute',
          left: '-10000px',
          top: 'auto',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
      >
        <VideoGeneratorHeroPlayer />
      </div>
      <HeroSection />
      <HowToUseSection />
      <PowerfulFeaturesSection />
      <UseCasesSection />
      <WhyChooseSection />
      <ComparisonSection />
      <TestimonialsSection />
      <ExploreToolsSection />
      <FAQSection />
      <CTASection />
    </>
  );
};

export default SEOSections;

// 也导出单独的组件,方便按需引入
export {
  ComparisonSection,
  CTASection,
  ExploreToolsSection,
  FAQSection,
  HeroSection,
  HowToUseSection,
  PowerfulFeaturesSection,
  TestimonialsSection,
  UseCasesSection,
  WhyChooseSection,
};
export { default as StartButton } from './StartButton';
